import { VisualListContent } from "./AthleteSummary";
import { T } from "components/util/t";

export const TeamSummary = ({ entries, entry }) => <VisualListContent text={entry.registrations_attributes[0].name} subtext={<T x={entries.length}>x_teams</T>} />;
